var map = {
	"./add.svg": "76b5",
	"./all.svg": "ac0b",
	"./angellist.svg": "b059",
	"./f6s.svg": "11fa",
	"./facebook.svg": "8708",
	"./flickr.svg": "0ea4",
	"./github.svg": "c345a",
	"./gitlab.svg": "6e38",
	"./google.svg": "e438",
	"./googleid.svg": "fd0c",
	"./instagram.svg": "ca15",
	"./linkedin.svg": "ed1e",
	"./medium.svg": "f359",
	"./other.svg": "ece9",
	"./pinterest.svg": "3a0d",
	"./skype.svg": "eec6",
	"./stackoverflow.svg": "acec",
	"./twitter.svg": "9426",
	"./website.svg": "b05ec",
	"./youtube.svg": "92fc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "397e";